import { TextField } from "@material-ui/core";
import axios from "axios";
import { isValidTurkishPhoneNumber } from "helpers/PhoneFormats";
import LayoutV1 from "markup/Layout/LayoutV1";
import PhoneField from "modules/Auth/parts/PhoneField";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function PaidAdvertContactPage() {
  const User = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    fullname: "",
    subject: "",
    message: "",
    email: "",
    phoneNumber: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleFormData = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const submitForm = (e) => {
    e.preventDefault();

    setSuccess(false);
    const { fullname, subject, message, email, phoneNumber } = formData;

    if (!fullname || !subject || !message || !email || !phoneNumber)
      return toast.error("Lütfen tüm alanları doldurun");

    if (!isValidTurkishPhoneNumber(phoneNumber))
      return toast.error("Lütfen geçerli bir telefon numarası giriniz");

    setIsLoading(true);
    axios
      .post("/v1/paidAdvertisement/contact", formData)
      .then(() => {
        setIsLoading(false);
        setSuccess(true);
        toast.success(
          "Talebiniz alındı, reklam ekibimiz en kısa sürede sizinle iletişime geçecek"
        );

        setFormData({
          fullname: "",
          subject: "",
          message: "",
          email: "",
          phoneNumber: "",
        });
      })
      .catch((err) => {
        setSuccess(false);
        setIsLoading(false);
        if (err?.response?.data?.message)
          toast.error(err?.response?.data?.message);
      });
  };

  return (
    <LayoutV1>
      <Helmet>
        <title>Alıcılar</title>
        <meta
          name="description"
          content="Almak istediğin ne varsa ilan ver satıcısı seni bulsun !"
        />
      </Helmet>

      <div className="container py-3">
        <h3 className="text-center">Reklam Ver</h3>
        <p className="text-center" style={{ color: "#4A5750", marginBottom: 24 }}>
          Markanızı milyonlarca alıcı ve satıcıya ulaştırın. Bilgilerinizi
          bırakın, reklam ekibimiz en kısa sürede sizinle iletişime geçsin.
        </p>

        <form onSubmit={submitForm}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <TextField
                type="text"
                name="fullname"
                variant="outlined"
                label="İsim"
                onChange={(e) => handleFormData("fullname", e.target.value)}
                value={formData.fullname}
                style={{ width: "100%", background: "white" }}
              />
            </div>

            <div className="col-md-4 mb-3">
              <TextField
                type="email"
                name="email"
                variant="outlined"
                label="E-Posta"
                onChange={(e) => handleFormData("email", e.target.value)}
                value={formData.email}
                style={{ width: "100%", background: "white" }}
              />
            </div>

            <div className="col-md-4 mb-4">
              <PhoneField
                value={formData.phoneNumber}
                onChange={(e) => handleFormData("phoneNumber", e.target.value)}
                style={{
                  minHeight: 50,
                  height: "100%",
                  borderRadius: 5,
                  borderColor: "#ccc",
                }}
              />
            </div>

            <div className="mb-3 col-12">
              <TextField
                type="text"
                name="subject"
                variant="outlined"
                label="Konu"
                onChange={(e) => handleFormData("subject", e.target.value)}
                value={formData.subject}
                style={{ width: "100%", background: "white" }}
              />
            </div>

            <div className="mb-3 col-12">
              <TextField
                type="text"
                name="message"
                variant="outlined"
                label="Ne hakkında reklam vermek istiyorsunuz?"
                multiline
                rows={10}
                onChange={(e) => handleFormData("message", e.target.value)}
                value={formData.message}
                style={{ width: "100%", background: "white" }}
              />
            </div>
          </div>

          <div className="row">
            {success ? (
              <div className="col-12">
                <div
                  style={{
                    background: "#E9F8F1",
                    border: "1px solid #1FB284",
                    borderRadius: 10,
                    padding: "16px 20px",
                    color: "#0F2D22",
                    fontWeight: 600,
                  }}
                >
                  Talebiniz alındı. Reklam ekibimiz konuyla ilgili en kısa
                  sürede sizinle iletişime geçecektir.
                </div>
              </div>
            ) : (
              <div className="col-12">
                <button
                  className="btn text-white"
                  style={{
                    background: "#1FB284",
                    padding: "10px 28px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {isLoading ? "Gönderiliyor..." : "Reklam Talebi Gönder"}
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </LayoutV1>
  );
}

export default PaidAdvertContactPage;
